// extracted by mini-css-extract-plugin
export var cartContainer = "_mv-4";
export var gray = "_mv-1";
export var itemContainer = "_mv-2";
export var itemDetails = "_mv-3";
export var strong = "_mv-0";